module.exports = __webpack_public_path__ + "img/hamberger_01_02.858089dd.png";